import NewButton from "./newButton";
import { ButtonTypes } from "../../Definitions";
import { colors, frames } from "../../Styles";

interface TableButtonProps {
  content: string;
  startEnhancer: string | JSX.Element;
  onClick: () => void;
  disabled: boolean;
  startPosition?: number;
  gridArea?: string;
}

const TableButton = ({ content, startEnhancer, onClick, disabled, gridArea, startPosition = 180}: TableButtonProps) => {

  return (
    <frames._grid_bluePrintButton_container
      style={{ bottom: `${startPosition}px` }}
    >
      <NewButton
        content={content}
        startEnhancer={startEnhancer}
        buttonType={ButtonTypes.textButton}
        overrides={{
          baseStyles: {
            backgroundColor: colors.greySecondary,
            padding: "6px 8px",
            borderRadius: "8px 8px 0 0",
            userSelect: "none",
            height: "fit-content",
          },
          hoverStyles: { backgroundColor: colors.greyPrimary, opacity: "1" },
          startEnhancerStyles: { transform: "rotate(-45deg)" },
        }}
        onClick={onClick}
        disabled={disabled}
      />
    </frames._grid_bluePrintButton_container>
  );
};

export default TableButton;
